import React from "react"
import classNames from "classnames"

interface Props {
  isViable: boolean
}

const ViabilityIndicator = ({ isViable }: Props) => {
  const iconContainerClass = classNames("rounded p-3", {
    "bg-green-600": isViable,
    "bg-red-600": !isViable,
  })

  const iconClass = classNames("fa fa-2x fa-fw fa-inverse", {
    "fa-thumbs-up": isViable,
    "fa-thumbs-down": !isViable,
  })

  return (
    <div className="bg-white border rounded shadow p-2">
      <div className="flex flex-row items-center">
        <div className="flex-shrink pr-4">
          <div className={iconContainerClass}>
            <i className={iconClass}></i>
          </div>
        </div>
        <div className="flex-1 text-right md:text-center">
          <h5 className="font-bold uppercase text-gray-500">Prediction</h5>
          <h3 className="font-bold text-3xl">
            {isViable ? "1M+ Owners" : "<1M+ Owners"}
          </h3>
        </div>
      </div>
    </div>
  )
}

export default ViabilityIndicator
